import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const Index = () => {
  const navigate = useNavigate();

  const handleRedirect = async (e) => {
    navigate("/login");
  };
  return (
    <div className="container1" style={{ alignContent: "center" }}>
      <div className="pcont align-content-center">
        <div className="p-4">
          <div className="row">
            <div className="col-md-4 offset-md-4">
              <img
                alt=""
                src="/images/group.png"
                style={{
                  width: "9rem",
                  height: "8rem",
                  display: "flex",
                  margin: "auto",
                }}
              />
              <div className="textJ">Pronto</div>
              <div
                className="textJ mt-2"
                style={{ fontSize: "12px", fontWeight: "400" }}
              >
                Powered by <div>Health Monitor</div>
              </div>

              <div
                className="textJ mt-2"
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  fontSize: "17px",
                  paddingTop: "20px",
                }}
              >
                You can login from this button
              </div>
              <div
                className="textJ"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  textDecorationLine: "underline",
                  color: "black",
                  paddingTop: "20px",
                }}
              >
                <button
                  onClick={handleRedirect}
                  className="mb-3 mt-3  btnlogin"
                >
                  <div>Log In</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;